<script setup lang="ts">
import Skeleton from '@/application/components/ui/Skeleton.vue';

</script>

<template>
  <div class="flex flex-col gap-5 p-4">
    <Skeleton gradient class="h-20" />
    <Skeleton gradient class="h-44" />
    <Skeleton gradient class="h-12" />
  </div>
</template>
